module.exports = __webpack_public_path__ + "static/media/Employee_Census_Template.f6235106.xlsx";